'use strict';


app.factory('Preloader', ['ngDialog', '$timeout', 
    function (ngDialog, $timeout) {
        var service = {};

        var is_opened = false;


        /**
         * open preloader
         */
        service.open = function(){

            if(is_opened) return;

        	ngDialog.open({
			    template: '<div id="loader-wrapper">\
			                  <div id="loader"></div>\
			                  <div class="loader-section section-left"></div>\
			                  <div class="loader-section section-right"></div>\
			              </div>',
			    plain: true,
			    className: 'ngdialog-preloader',
			    showClose: false,
			    closeByDocument: false,
			    closeByEscape: false,
			    closeByNavigation: true
			});

			$timeout(function(){
				$('#loader-wrapper').css('margin-top', (window.innerHeight/2 - 40) );
			}, 100);

            is_opened = true;
        }


        /**
         * close preloader
         */
        service.close = function(){
            is_opened = false;
        	ngDialog.closeAll();
        }


        return service;
    }]);